<template>
    <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
    <v-card>
        <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
              <v-flex xs12>
                <v-btn fab x-small @click="$router.go(-1)">
                  <v-icon>navigate_before</v-icon>
                    
                  </v-btn>
              </v-flex>

              <v-flex xs12 md1 class="mb-2">
                <v-btn 
                    fab 
                    small
                    @click="printTable()"
                    class="ml-8 white--text"
                    color="#2b6993"
                    elevation="4"
                    absolute 
                    right
                    >
                    <v-icon>print</v-icon>
                </v-btn>
              </v-flex>

              <v-flex xs12>
                <h3 class="text-center mb-5">HAB Report</h3>
                <v-divider class="ml-4 mr-4 mb-3"></v-divider>
              </v-flex>

              <v-flex xs12>
                <v-card
                  class="ma-3 pa-3"
                  elevation="0"
                >
                  <v-layout row wrap>
                    <v-flex xs12 md3 class="pa-1" >
                      <v-menu
                          ref="calendarMenu"
                          v-model="calendarMenu"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                          <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              @change="getQueryData"
                              v-model="startDate"
                              label="Start Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :rules='requiredField'
                              clearable
                          ></v-text-field>
                          </template>
                          <v-date-picker
                          v-model="startDate"
                          no-title
                          scrollable
                          :rules='requiredField'

                          >
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              color="primary"
                              @click="calendarMenu = false"
                          >
                              Cancel
                          </v-btn>
                          <v-btn
                              text
                              color="primary"
                              @click="$refs.calendarMenu.save(date)"
                          >
                              OK
                          </v-btn>
                          </v-date-picker>
                      </v-menu>
                      
                  </v-flex>

                  <v-flex xs12 md3 class="pa-1 hideOnPrint">
                    <v-menu
                          ref="calendar2Menu"
                          v-model="calendar2Menu"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                          <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              @change="getQueryData"
                              v-model="endDate"
                              label="End Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :rules='requiredField'
                              clearable

                          ></v-text-field>
                          </template>
                          <v-date-picker
                          v-model="endDate"
                          no-title
                          scrollable
                          :rules='requiredField'

                          >
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              color="primary"
                              @click="calendar2Menu = false"
                          >
                              Cancel
                          </v-btn>
                          <v-btn
                              text
                              color="primary"
                              @click="$refs.calendar2Menu.save(date)"
                          >
                              OK
                          </v-btn>
                          </v-date-picker>
                      </v-menu>
                  </v-flex>

                  <v-flex xs12 md3 class="pa-1 mb-2 hideOnPrint">
                    <v-select
                        @change="getQueryData"
                        label="Select a Client"
                        :items="clients"
                        item-text="Name"
                        item-value="_id"
                        v-model="ClientID"
                        clearable
                        :required="requiredField"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 md3 class="mt-5 mb-5 pl-5">
                      <!-- <v-btn 
                        fab 
                        small
                        @click="printTable()"
                        class="mr-8 mb-2 white--text"
                        color="#2b6993"
                        elevation="4"
                        >
                        <v-icon>print</v-icon>
                    </v-btn> -->

                    <v-btn 
                        small 
                        @click="getQueryData()"
                        class="ma-1"
                        
                        >Search</v-btn>
                    <v-btn
                        small
                        @click="downloadMarCSV()"
                        class="ma-1"

                    >Download</v-btn>
                  </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
          <v-dialog v-model="dialog" max-width="80%">
            <v-card>
              <v-card-title style="background-color: #2b3990">
                <span class="headline white--text">{{ titleForm  }}</span>
              </v-card-title>
             <v-row>
               <v-col
                   cols="12"
                   sm="6"
               >
                 <v-textarea
                     class="mt-3 ml-3"
                     label="Medication Type"
                     auto-grow
                     outlined
                     row-height="15"
                     v-model="medication"
                     readonly
                 ></v-textarea>
               </v-col>
               <v-col
                   cols="12"
                   sm="6"
               >
                 <v-textarea
                     class="mt-3 mr-3"
                     label="Amount Administered"
                     auto-grow
                     outlined
                     rows="1"
                     row-height="15"
                     v-model="amountAdministered"
                     readonly
                 ></v-textarea>
               </v-col>
             </v-row>
              <v-row>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-textarea
                      class="mt-3 ml-3"
                      label="Admin Time"
                      auto-grow
                      outlined
                      row-height="15"
                      v-model="adminTime"
                      readonly
                  ></v-textarea>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-textarea
                      class="mt-3 mr-3"
                      label="Actual Admin Time"
                      auto-grow
                      outlined
                      rows="1"
                      row-height="15"
                      v-model="actualAdminTime"
                      readonly
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-textarea
                      class="mt-3 ml-3"
                      label="Notes/Instructions"
                      auto-grow
                      outlined
                      row-height="15"
                      v-model="notes"
                      readonly
                  ></v-textarea>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-textarea
                      class="mt-3 mr-3"
                      label="Exception"
                      auto-grow
                      outlined
                      rows="1"
                      row-height="15"
                      v-model="exception"
                      readonly
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-textarea
                      class="mt-3 ml-3"
                      label="Signature"
                      auto-grow
                      outlined
                      row-height="15"
                      v-model="signature"
                      readonly
                  ></v-textarea>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-textarea
                      class="mt-3 mr-3"
                      label="Verified By:"
                      auto-grow
                      outlined
                      rows="1"
                      row-height="15"
                      v-model="verifiedBy"
                      readonly
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-textarea
                      class="mt-3 ml-3"
                      label="Date"
                      auto-grow
                      outlined
                      row-height="15"
                      v-model="marDate"
                      readonly
                  ></v-textarea>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-textarea
                      class="mt-3 mr-3"
                      label="Client Name"
                      auto-grow
                      outlined
                      rows="1"
                      row-height="15"
                      v-model="clientID"
                      readonly
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-textarea
                      class="mt-3 ml-3"
                      label="Staff Name"
                      auto-grow
                      outlined
                      row-height="15"
                      v-model="staffID"
                      readonly
                  ></v-textarea>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-textarea
                      class="mt-3 mr-3"
                      label="Quantity"
                      auto-grow
                      outlined
                      rows="1"
                      row-height="15"
                      v-model="quantity"
                      readonly
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-textarea
                      class="mt-3 ml-3"
                      label="Vitals Required"
                      auto-grow
                      outlined
                      row-height="15"
                      v-model="vitalsRequired"
                      readonly
                  ></v-textarea>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-textarea
                      class="mt-3 mr-3"
                      label="Follow Up PRN"
                      auto-grow
                      outlined
                      rows="1"
                      row-height="15"
                      v-model="followUpPRN"
                      readonly
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-btn
                    style="background-color: #2b3990"
                    text
                    @click="close"
                >
                  <span class="white--text">Close</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
              


              <v-flex xs12 class="pa-2 hideOnPrint">
                  <v-data-table
                     
                      :headers="headers"
                      :items="mars"
                      sort-by="Name"
                      sort-desc
                      class="elevation-1"
                      :loading="isLoading"
                      loading-text="Loading MAR"

                  >
                  <!--
                  <template v-slot:item.select="{ item }">
                      <v-btn
                        x-small
                        class="white--text"
                        color="#2b3990"
                        @click="viewMAR(item)"
                      >
                        view
                      </v-btn>
                  </template>
                  -->
                  </v-data-table>

              </v-flex>
            </v-layout>
          </v-card>
          <div id="printTable">
            <h2 class="text-center">1 Month MAR Summary</h2>
              <v-row row wrap>
                  <v-col cols="4">
                    <v-text-field
                        v-model="startDate"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules='requiredField'
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                      <v-text-field
                        v-model="endDate"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules='requiredField'
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-select 
                        label="Select a Client"
                        :items="clients"
                        item-text="Name"
                        item-value="_id"
                        v-model="ClientID"
                        clearable
                        :required="rules"
                    ></v-select>
                  </v-col>
                  <v-col cols='12'>
                      
                    <v-data-table
                        :headers="headers"
                        :items="mars"
                        sort-by="Date"
                        sort-asc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading MARS"
                        :items-per-page="-1"

                    >
                    <!-- <template v-slot:item.select="{ item }">
                        <v-btn
                            x-small
                            class="white--text"
                            color="#2b3990"
                            @click="viewMAR(item)"
                        >
                            view
                        </v-btn>         
                    </template> -->
                    </v-data-table>

                </v-col>
              </v-row>
          </div>
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

  export default {
    components: {
    },
    data: () => ({
    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: true,
        value: 'Date',
      },
      { text: "Client", value: "ClientID.Name" },
      { text: "HAB Plan", value: "HABPlan.SupportPlan" },
      { text: "HAB Plan Step", value: "StepDescription" },
      { text: "Signature", value: "Signature" },
      { text: "", value: "select" },

    ],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    clients: [],
    mars: [],
    programs: [],
    status: ['Complete', 'Incomplete'],
    startDate: "",
    endDate: "",
    ClientID: '',
    calendarMenu: false,
    calendar2Menu: false,
    report: '',
    clientName: '',
    isLoading: false,
    program: "",
    userState: localStorage.getItem('userState'),
    page: 1,
    pageCount: 1,
    itemCount: 0,
    options: {},
    requiredField: [
        v => !!v || 'This is required',
    ],
    dialog: false,
    medication: '',
    amountAdministered: '',
    adminTime: '',
    actualAdminTime: '',
    notes: '',
    exception: '',
    signature: '',
    verifiedBy: '',
    marDate: '',
    clientID: '',
    staffID: '',
    quantity: '',
    followUpPRN: '',
    vitalsRequired: '',
    model: 'tab-2',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    }),

    computed: {
      
    },

    watch: {
      // options: {
      //   handler() {
      //     this.getMars();
      //   },
      //   deep: true
      // }
    },

    created() {
      this.getClients();
      this.getHabSigned();
    //   this.getPrograms();
    },

    methods: {
      initialize() {
        this.clients = [];
      },

      getClients () {
        axios.get(`${url}/clients/state/${this.userState}`).then(async res => {
          this.clients = res.data.clients;
          
        });      
      },

    //   getPrograms () {
    //     axios.get(`${url}/units/state/${this.userState}`).then(async res => {
    //       this.programs = res.data.units;
          
    //     });      
    //   },

      close() {
        this.dialog = false;
        this.seditInfo = false;
        this.passdialog = false;
        this.chgimg = false;

      },

      getHabSigned() {
        let { page, itemsPerPage } = this.options;
        page = page || 1;
        itemsPerPage = 100;
        this.isLoading = true;

         axios.get(`${url}/hab/report?page=${page}&limit=${itemsPerPage}&state=${this.userState}`).then(response => {
          
          const {docs, totalPages, totalDocs } = response.data;

          if (docs && docs.length > 0) {
            this.mars = docs.filter(doc => this.userState === doc.ClientID.State).map(doc => {
              doc.Date = moment(doc.Date).format("MM/DD/YYYY");
              return doc;
            });

            console.log({ mars: this.mars});
          }
          

          this.pageCount = totalPages;
          this.itemCount = totalDocs;
          this.isLoading = false;
        
        })
      },


      getQueryData() {
        this.isLoading = true
        if(this.ClientID == ''){
          axios.get(`${url}/hab/${this.startDate}/${this.endDate}`).then(res => {
            this.mars = res.data.mars.map(doc => {
              doc.Date = moment(doc.Date).format("MM/DD/YYYY");
              return doc;
            });
            
          })
          .finally(() => (this.isLoading = false));
          
        } else {
          axios.get(`${url}/hab/${this.startDate}/${this.endDate}/${this.ClientID}`).then(res => {
            this.mars = res.data.mars.map(doc => {
              doc.Date = moment(doc.Date).format("MM/DD/YYYY");
              return doc;
            });
          })
          .finally(() => (this.isLoading = false));
        }
        
      },

      downloadMarCSV() {

        const startDate = new Date(`${this.startDate}`).toISOString()
        const endDate = new Date(`${this.endDate}`).toISOString()

        window.location.href = `${url}/mar/download?clientId=${this.ClientID}&startDate=${startDate}&endDate=${endDate}`;
      },

      getClientID(item) {
        this.client = item.ClientID._id;
        window.localStorage.setItem('clientId', this.client)
        console.log(this.client)
      },

      printTable() {
        
        window.print()
      
    },

      printItem() {
        document.getElementById('printTable').style.display = "none";
      
        window.print()
    },

      viewMAR(item) {
        this.titleForm= "Viewing MAR";
        this.dialog = true;
        this.marID = item._id;
        this.medication = item.Medication.Medication;
        this.amountAdministered = item.Medication.AdministerAmount;
        this.adminTime = item.Medication.AdminTime;
        this.actualAdminTime = item.AdminTime;
        this.notes = item.Medication.MARInstructions;
        this.exception = item.Exception;
        this.signature = item.Signature;
        this.verifiedBy = item.VerifiedBy;
        this.marDate = item.Date;
        this.clientID = item.ClientID.Name;
        this.staffID = item.Medication.StaffID.Name;
        this.quantity = item.Medication.Quantity;
        this.followUpPRN = item.FollowUpPRN;
        this.vitalsRequired = item.Medication.VitalsRequired;
      },
    }
  }
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }

  #printTable{
    display: none;
  }

  #printItem{
    display: none;
  }

  @media only screen and (min-width: 768px) {
      .mobile {
        display: none;
      }
    }

    @media only screen and (max-width: 600px) {
      .desktop {
        display: none;
      }

    }

    @media print { 
      #printTable{ 
      display: block; 
      border: none; 
      width: 1300px;
      padding-right: 300px;
      margin-left: -200px;

      }
     
      .hideOnPrint {
        display: none;
        border: none; 
      }

      nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none; 

      }

      @page { margin: 0; }
      body { margin: 1.6cm; }
    
      
    } 
</style>
